import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, Observable, of } from 'rxjs';

/** Inbound SMS reply shown in the bell. */
export interface OiqSmsAlert {
  smsMessageId: number;
  body: string;
  receivedAt: string;
  fromName: string | null;
  fromNumber: string;
  smsThreadId: number;
  clientId: number;
  /** null when the conversation has no contact (same as fromName). */
  contactId: number | null;
  clientName: string;
  fundingId: number | null;
  applicationId: number | null;
}

export interface OiqSmsAlertsUnreadCount {
  count: number;
  hasUnread: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class OiqSmsAlertsService {
  constructor(private http: HttpClient) {}

  unreadCount(): Observable<OiqSmsAlertsUnreadCount> {
    return this.http
      .get<OiqSmsAlertsUnreadCount>('sms-alerts/unread-count')
      .pipe(catchError(() => of({ count: 0, hasUnread: false })));
  }

  list(): Observable<OiqSmsAlert[]> {
    return this.http.get<OiqSmsAlert[]>('sms-alerts');
  }

  markRead(smsMessageIds: number[]): Observable<void> {
    return this.http.post<void>('sms-alerts/read', smsMessageIds);
  }
}
